import moment from "moment";

export const API_URL = "http://api.cvptv.pt/v1/";

export const formatDate = date => date !== null && moment(date).format('DD/MM/YYYY');
export const formatDateTime = dateTime => dateTime !== null && moment(dateTime).format('DD/MM/YYYY HH:mm');